import {Injectable} from '@angular/core';

@Injectable()
export class LocalStorageDataServiceService {

  private serviceData = new DataServiceType();

  setToDataObject(key: string, data: any) {
    this.serviceData.data = this.serviceData.data === null ? {} : this.serviceData.data;
    this.serviceData.data[key] = data;
    window.localStorage.setItem('data', JSON.stringify(this.getFullData()));
  }

  getData(key: string) {
    return this.serviceData.data[key];
  }

  setUrl(url: string) {
    try {
      this.serviceData.url = url;
    } catch (ex) {
      this.serviceData = new DataServiceType();
    }
  }

  getUrl() {
    try {
      return this.serviceData.url;
    } catch (ex) {
      return '/';
    }
  }

  setFullData(data: DataServiceType) {
    this.serviceData = data;
  }

  getFullData(): DataServiceType {
    return this.serviceData;
  }

  loadFromLocalStorage() {
    const localData = window.localStorage.getItem('data');
    if (localData !== '') {
      this.setFullData(JSON.parse(localData));
    }
  }

}

class DataServiceType {
  data: any = {};
  url = '';

  constructor() {
    this.data = {};
    this.url = '';
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/local-storage-data-service.service.ts